import './hud-container.css';

export type HudSlot =
  | 'top-left'
  | 'top-center'
  | 'top-right'
  | 'bottom-left'
  | 'bottom-center'
  | 'bottom-right';

const ALL_SLOTS: HudSlot[] = [
  'top-left',
  'top-center',
  'top-right',
  'bottom-left',
  'bottom-center',
  'bottom-right',
];

export interface HudContainerHandle {
  readonly el: HTMLElement;
  slot(name: HudSlot): HTMLElement;
  clear(name?: HudSlot): void;
  destroy(): void;
}

export function createHudContainer(): HudContainerHandle {
  const el = document.createElement('div');
  el.className = 'fg-hud';

  const slotMap = {} as Record<HudSlot, HTMLElement>;
  for (const name of ALL_SLOTS) {
    const s = document.createElement('div');
    s.className = `fg-hud__slot fg-hud__slot--${name}`;
    el.appendChild(s);
    slotMap[name] = s;
  }

  return {
    el,
    slot(name) {
      return slotMap[name];
    },
    clear(name) {
      if (name) {
        slotMap[name].replaceChildren();
      } else {
        for (const s of Object.values(slotMap)) s.replaceChildren();
      }
    },
    destroy() {
      el.remove();
    },
  };
}
